import cn from 'classnames';
import React from 'react';
import { Grid } from '@chakra-ui/react';
import styles from './Footer.module.scss';

export type FooterProps = {
    className?: string
}

export const Footer = ({
    className,
}: FooterProps) => (
    <Grid
        background="#000000"
    >
        <Grid
            className={cn(className, styles.footer)}
            maxWidth={{
                base: '425px',
                lg: '1280px',
            }}
            width="100%"
            margin="0 auto"
        >
            <span>
                Кейтеринг CORSO ©2026
            </span>
        </Grid>
    </Grid>
);
